const btn = document.querySelector('button[data-share]');

if (btn && navigator.share) {
  const { share } = btn.dataset;
  const shareData = JSON.parse(share);

  btn.addEventListener('click', async () => {
    try {
      await navigator.share(shareData);
    } catch (e) {
      console.error(e);
    }
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/mobileSharer.js